export default "__VITE_ASSET__ae6def76__"